import { render, staticRenderFns } from "./FeeTabs.vue?vue&type=template&id=623efa6c&scoped=true"
import script from "./FeeTabs.vue?vue&type=script&lang=js"
export * from "./FeeTabs.vue?vue&type=script&lang=js"
import style0 from "./FeeTabs.vue?vue&type=style&index=0&id=623efa6c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623efa6c",
  null
  
)

export default component.exports